import { MedplumClient } from "@medplum/core";
import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { Questionnaires } from "@/fhir/enums/questionnaires";

/**
 * Finds the client's current intake response, the one a GTPAL drawer save updates.
 *
 * @param medplum Authenticated Medplum client.
 * @param subject `Patient/{id}` of the client.
 * @returns The most recently updated in-progress intake response, if the client has one.
 */
export async function findCurrentIntakeQuestionnaireResponse(
  medplum: MedplumClient,
  subject: string,
): Promise<QuestionnaireResponse | undefined> {
  return medplum.searchOne("QuestionnaireResponse", {
    subject,
    identifier: Questionnaires.ClientIntake,
    status: "in-progress",
    _sort: "-_lastUpdated",
  });
}
